import { Button, Typography } from '@libs/components';
import styled from 'styled-components';
import AssetRow from '../asset-row/AssetRow';
export const Full = styled.div`
  flex: 1;
  margin-bottom: 2rem;
`;

export const Container = styled.div`
  padding: 0;
`;
export const AssetsContainer = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.x4};
  background-color: ${({ theme }) => theme.colors.surface.tertiary};
  padding: 0 2rem;
`;

export const AssetContainer = styled.div`
  padding: 1.6rem 0;
  display: flex;

  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
export const Separator = styled.div`
  position: relative;
  height: 0.1rem;
  background-color: ${({ theme }) => theme.colors.borders.default};
`;

export const SeparatorThin = styled.div`
  position: relative;
  height: 0.1rem;
  background-color: ${({ theme }) => theme.colors.borders.default};
`;

export const IconContainer = styled.div`
  display: flex;

  top: -1.4rem;
  left: 0;
  right: 0;
  position: absolute;
  align-items: center;
  justify-content: center;
`;
export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(90deg);
  width: 3.2rem;
  height: 3.2rem;
  border-radius: ${({ theme }) => theme.borderRadius.x4};
  background-color: ${({ theme }) => theme.colors.surface.tertiary};
`;
export const DetailsWrapper = styled.div`
  padding: 0 2rem;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ChangeButton = styled(Button)`
  padding: 0 1rem;
  width: unset;
`;

export const DetailRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 1.6rem 0;
`;
export const TextWithProgress = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ProgressBar = styled.div`
  width: 1.6rem;
  height: 1.6rem;
  margin-right: 0.2rem;
`;

export const ProgressBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.4rem;
  border-radius: ${({ theme }) => theme.borderRadius.x5};
  background-color: ${({ theme }) => theme.colors.interactive.secondary};
  margin-left: 0.4rem;
`;
export const BorderBox = styled.div`
  padding: 0.4rem;
  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.x4};
`;

export const ConfirmSectionWrapper = styled.div`
  margin-top: 3.2rem;
  display: flex;
  flex-direction: column;
`;

export const CustomImg = styled.img`
  width: 3.2rem;
`;

export const WalletWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 1.6rem 0 2.6rem;
  gap: 0.8rem;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CustomAssetRow = styled(AssetRow)`
  .icon {
    margin-right: 0.4rem;
    max-width: 3.2rem;
    max-height: 3.2rem;
  }
  .asset-icon {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const CustomTypography = styled(Typography)`
  margin-bottom: 1.6rem;
`;
